import { supabase } from "@/integrations/supabase/client";

export interface CompanyAccountRow {
  id: string;
  account: string;
  description: string;
}

export const loadCompanyAccountCatalog = async (
  companyId: string,
): Promise<CompanyAccountRow[]> => {
  const { data, error } = await supabase
    .from("company_account_catalog")
    .select("id, account, description")
    .eq("company_id", companyId)
    .order("account");
  if (error) {
    console.error("Error loading company account catalog:", error);
    return [];
  }
  return data || [];
};

export const insertCompanyAccount = async (
  companyId: string,
  account: string,
  description: string,
): Promise<{ data?: CompanyAccountRow; error?: string }> => {
  const { data, error } = await supabase
    .from("company_account_catalog")
    .insert({ company_id: companyId, account: account.trim(), description: description.trim() })
    .select("id, account, description")
    .single();
  if (error) return { error: error.message };
  return { data: data as CompanyAccountRow };
};

export const updateCompanyAccount = async (
  id: string,
  account: string,
  description: string,
): Promise<{ error?: string }> => {
  const { error } = await supabase
    .from("company_account_catalog")
    .update({ account: account.trim(), description: description.trim() })
    .eq("id", id);
  return { error: error?.message };
};

export const deleteCompanyAccount = async (id: string): Promise<{ error?: string }> => {
  const { error } = await supabase
    .from("company_account_catalog")
    .delete()
    .eq("id", id);
  return { error: error?.message };
};
